if (!customElements.get('mmlc-story-video')) {
  customElements.define('mmlc-story-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-story-play]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const id = link.dataset.videoId;
        if (!/^[\w-]{11}$/.test(id)) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.title = link.querySelector('img').alt;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      });
    }
  });
}
